import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

// Read brand colors injected by the backend (Front\MainController -> EasyEvent.theme).
// All values live in the `config.theme` JSON in DB and are editable in
// Admin > Settings > Theme.
const t = (typeof EasyEvent !== 'undefined' && EasyEvent.theme) ? EasyEvent.theme : {}

// Single palette shared by both light and dark themes — Vuetify still uses
// the `dark` flag to pick the surface/text defaults (dark cards, white text,
// dark dialogs, etc.) but our brand colors stay identical across modes.
const palette = {
  primary:   t.primary_color   || '#60d7ff',
  secondary: t.secondary_color || '#003366',
  accent:    t.accent_color    || '#003366',

  // Status colors — no admin field exists for these; safe to hardcode.
  error:   '#d44950',
  info:    '#60d7ff',
  success: '#1d9d74',
  warning: '#ffb74d',
}

const opts = {
  theme: {
    // Dark mode globally — Vuetify renders cards, lists, dialogs, menus,
    // inputs, toolbars and dividers with dark surfaces and white text out
    // of the box. Drastically reduces the amount of custom CSS needed.
    dark: true,

    // Emit CSS custom properties for theme colors:
    //   --v-primary-base, --v-primary-lighten1, --v-secondary-base, etc.
    options: { customProperties: true },

    themes: {
      light: palette,
      dark:  palette,
    }
  }
}

export default new Vuetify(opts)
